import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={44.273}
      height={44.273}
      viewBox="0 0 44.273 44.273"
      {...props}
    >
      <g data-name="bulb (3)">
        <g data-name="Group 252" transform="translate(.714 .714)">
          <path
            data-name="Path 3362"
            d="M3.57 3.57h35.7v35.7H3.57z"
            fill="#165a9f"
          />
          <path
            data-name="Path 3363"
            d="M30.704 16.241a9.28 9.28 0 01-4.8 8.316 1.778 1.778 0 00-.914 1.558v2.452h-7.141v-2.456a1.785 1.785 0 00-.921-1.562 9.284 9.284 0 1113.773-8.311z"
            fill="#ffd200"
          />
          <path
            data-name="Path 3364"
            d="M15.71 28.564h11.425v2.142H15.71z"
            fill="#d8d7da"
          />
          <path
            data-name="Path 3365"
            d="M17.138 30.706h8.569v3.213a1.785 1.785 0 01-1.785 1.787h-5a1.785 1.785 0 01-1.784-1.787z"
            fill="#003586"
          />
          <path
            data-name="Path 3366"
            d="M23.565 35.704h-4.374l.714-2.856h2.946z"
            fill="#ff9811"
          />
          <g data-name="Group 251" fill="#ffda44">
            <path data-name="Path 3367" d="M19.994 0h2.856v3.57h-2.856z" />
            <path data-name="Path 3368" d="M12.854 0h2.856v3.57h-2.856z" />
            <path data-name="Path 3369" d="M5.713 0h2.856v3.57H5.713z" />
            <path data-name="Path 3370" d="M34.276 0h2.856v3.57h-2.856z" />
            <path data-name="Path 3371" d="M27.135 0h2.856v3.57h-2.856z" />
            <path data-name="Path 3372" d="M19.994 39.275h2.856v3.57h-2.856z" />
            <path data-name="Path 3373" d="M12.854 39.275h2.856v3.57h-2.856z" />
            <path data-name="Path 3374" d="M5.713 39.275h2.856v3.57H5.713z" />
            <path data-name="Path 3375" d="M34.276 39.275h2.856v3.57h-2.856z" />
            <path data-name="Path 3376" d="M27.135 39.275h2.856v3.57h-2.856z" />
            <path data-name="Path 3377" d="M0 22.851v-2.856h3.57v2.856z" />
            <path data-name="Path 3378" d="M0 29.992v-2.856h3.57v2.856z" />
            <path data-name="Path 3379" d="M0 37.133v-2.856h3.57v2.856z" />
            <path data-name="Path 3380" d="M0 8.569V5.713h3.57v2.856z" />
            <path data-name="Path 3381" d="M0 15.71v-2.856h3.57v2.856z" />
            <path data-name="Path 3382" d="M39.275 22.851v-2.856h3.57v2.856z" />
            <path data-name="Path 3383" d="M39.275 29.992v-2.856h3.57v2.856z" />
            <path data-name="Path 3384" d="M39.275 37.133v-2.856h3.57v2.856z" />
            <path data-name="Path 3385" d="M39.275 8.569V5.713h3.57v2.856z" />
            <path data-name="Path 3386" d="M39.275 15.71v-2.856h3.57v2.856z" />
          </g>
          <ellipse
            data-name="Ellipse 117"
            cx={1.402}
            cy={1.202}
            rx={1.402}
            ry={1.202}
            transform="translate(5.695 5.905)"
            fill="#d8d7da"
          />
          <circle
            data-name="Ellipse 118"
            cx={1.202}
            cy={1.202}
            r={1.202}
            transform="translate(34.536 5.905)"
            fill="#d8d7da"
          />
          <circle
            data-name="Ellipse 119"
            cx={1.402}
            cy={1.402}
            r={1.402}
            transform="translate(5.695 34.346)"
            fill="#d8d7da"
          />
          <ellipse
            data-name="Ellipse 120"
            cx={1.202}
            cy={1.402}
            rx={1.202}
            ry={1.402}
            transform="translate(34.536 34.346)"
            fill="#d8d7da"
          />
        </g>
        <g data-name="Group 253">
          <path
            data-name="Path 3387"
            d="M43.559 10a.714.714 0 00.714-.714V6.427a.714.714 0 00-.714-.714H40.7V4.285a.714.714 0 00-.714-.714h-1.425V.714A.714.714 0 0037.847 0H34.99a.714.714 0 00-.714.714V3.57H31.42V.714A.714.714 0 0030.706 0h-2.857a.714.714 0 00-.714.714V3.57h-2.856V.714A.714.714 0 0023.565 0h-2.856a.714.714 0 00-.714.714V3.57h-2.857V.714A.714.714 0 0016.424 0h-2.856a.714.714 0 00-.714.714V3.57H10V.714A.714.714 0 009.283 0H6.427a.714.714 0 00-.714.714V3.57H4.285a.714.714 0 00-.714.714v1.428H.714A.714.714 0 000 6.427v2.856A.714.714 0 00.714 10H3.57v2.856H.714a.714.714 0 00-.714.712v2.856a.714.714 0 00.714.714H3.57v2.856H.714a.714.714 0 00-.714.715v2.856a.714.714 0 00.714.714H3.57v2.856H.714a.714.714 0 00-.714.714v2.856a.714.714 0 00.714.714H3.57v2.856H.714A.714.714 0 000 34.99v2.856a.714.714 0 00.714.714H3.57v1.428a.714.714 0 00.714.714h1.428v2.856a.714.714 0 00.714.714h2.856a.714.714 0 00.718-.713V40.7h2.856v2.856a.714.714 0 00.714.714h2.856a.714.714 0 00.714-.714V40.7h2.856v2.856a.714.714 0 00.714.714h2.856a.714.714 0 00.714-.714V40.7h2.856v2.856a.714.714 0 00.714.714h2.856a.714.714 0 00.714-.714V40.7h2.856v2.856a.714.714 0 00.714.714h2.856a.714.714 0 00.714-.714V40.7h1.428a.714.714 0 00.714-.714v-1.425h2.856a.714.714 0 00.714-.714V34.99a.714.714 0 00-.714-.714H40.7V31.42h2.856a.714.714 0 00.714-.714v-2.857a.714.714 0 00-.714-.714H40.7v-2.856h2.856a.714.714 0 00.714-.714v-2.856a.714.714 0 00-.714-.714H40.7v-2.857h2.856a.714.714 0 00.714-.714v-2.856a.714.714 0 00-.714-.714H40.7V10zM40.7 7.141h2.142v1.428H40.7zM3.57 37.133H1.428V35.7H3.57zm0-7.141H1.428v-1.429H3.57zm0-7.141H1.428v-1.428H3.57zm0-7.141H1.428v-1.428H3.57zm0-7.141H1.428V7.141H3.57zM35.7 1.428h1.428V3.57H35.7zm-7.141 0h1.428V3.57h-1.424zm-7.141 0h1.428V3.57h-1.423zm-7.141 0h1.433V3.57h-1.428zm-7.141 0h1.428V3.57H7.141zm1.428 41.417H7.141V40.7h1.428zm7.141 0h-1.423V40.7h1.428zm7.141 0h-1.423V40.7h1.428zm7.141 0h-1.424V40.7h1.428zm7.141 0H35.7V40.7h1.428zm2.142-3.57H5V5h34.275zm3.57-3.57v1.428H40.7V35.7zm0-7.141v1.428H40.7v-1.429zm0-7.141v1.428H40.7v-1.428zm0-7.141v1.428H40.7v-1.428z"
          />
          <path
            data-name="Path 3388"
            d="M26.968 25.893A10 10 0 0022.28 7.141h-.145a10 10 0 00-4.836 18.748 1.072 1.072 0 01.553.936v1.738h-1.428a.714.714 0 00-.714.714v2.142a.714.714 0 00.714.714h.714v2.5a2.5 2.5 0 002.5 2.5h5a2.5 2.5 0 002.5-2.5v-2.5h.714a.714.714 0 00.714-.714v-2.142a.714.714 0 00-.714-.714h-1.428v-1.738a1.063 1.063 0 01.544-.932zm-6.147 9.812l.357-1.428h1.83l.357 1.428zm4.887-1.071a1.071 1.071 0 01-.876 1.052l-.574-2.3a.714.714 0 00-.693-.541h-2.946a.714.714 0 00-.693.541l-.57 2.277a1.071 1.071 0 01-.791-1.033v-2.5h7.141zm1.428-4.642v.714h-10v-.714zm-5.713-1.428v-12.14h1.425v12.139zm4.854-3.92a2.492 2.492 0 00-1.284 2.182v1.738h-.714v-12.14h.714a.714.714 0 100-1.428H19.28a.714.714 0 100 1.428h.714v12.139h-.714v-1.738a2.5 2.5 0 00-1.29-2.186 8.569 8.569 0 118.286 0z"
          />
          <path
            data-name="Path 3389"
            d="M7.855 5.713a2.142 2.142 0 102.142 2.142 2.142 2.142 0 00-2.142-2.142zm0 2.856a.714.714 0 11.714-.714.714.714 0 01-.714.714z"
          />
          <path
            data-name="Path 3390"
            d="M36.418 5.713a2.142 2.142 0 102.142 2.142 2.142 2.142 0 00-2.142-2.142zm0 2.856a.714.714 0 11.714-.714.714.714 0 01-.714.714z"
          />
          <path
            data-name="Path 3391"
            d="M7.855 34.276a2.142 2.142 0 102.142 2.142 2.142 2.142 0 00-2.142-2.142zm0 2.856a.714.714 0 11.714-.714.714.714 0 01-.714.714z"
          />
          <path
            data-name="Path 3392"
            d="M36.418 34.276a2.142 2.142 0 102.142 2.142 2.142 2.142 0 00-2.142-2.142zm0 2.856a.714.714 0 11.714-.714.714.714 0 01-.714.714z"
          />
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
